module.exports = __webpack_public_path__ + "img/wesuper.c97e010e.png";